import React, { PureComponent } from 'react';
import Collapsible from 'react-collapsible';
import { arraysEqual } from '../../../../../helpers/arrayUtils';

class Duration extends PureComponent {

  constructor(){
    super();

    this.state = {
      accordionOpen:true,
      accordiontransitionTime:300,
      activeFilter:""
    }

  }


  static getDerivedStateFromProps(nextProps, prevState){
     if(nextProps.active !== prevState.activeFilter){
        return {
          activeFilter:nextProps.active
        }
     }
     return null;
  }


  onDurationClick(e, daysArr, daysText){
    e.preventDefault();
    this.props.onSelect(daysArr, daysText);
  }


  setActiveFilter(currentItem){
    return arraysEqual(currentItem, this.state.activeFilter) ? 'active-filter' : "";
  }

  render(){
    return (
        <Collapsible
          trigger="Duration"
          open={this.state.accordionOpen}
          transitionTime={this.state.accordiontransitionTime}>

          <div className="filter-buttons">
            <div className="row">
              <div className="columns small-12 medium-6 no-pad-right"><button className={this.setActiveFilter([0,5])} onClick={e => this.onDurationClick(e, [0,5], "Up to 5 days") }>Up to 5 days</button></div>
              <div className="columns small-12 medium-6 no-pad-left"><button className={this.setActiveFilter([5,7])} onClick={e => this.onDurationClick(e, [5,7], "5 - 7 days") }>5 - 7 days</button></div>
              <div className="columns small-12 medium-6 no-pad-right no-margin"><button className={this.setActiveFilter([8,14])} onClick={e => this.onDurationClick(e, [8,14], "7 - 14 days") } >7 - 14 days</button></div>
              <div className="columns small-12 medium-6 no-pad-left no-margin"><button className={this.setActiveFilter([15,50])} onClick={e => this.onDurationClick(e, [15,50], "Over 14 days") }>Over 14 days</button></div>
            </div>
          </div>

        </Collapsible>
    )
  }
}

export default Duration;



// WEBPACK FOOTER //
// ./src/components/search/components/filters/components/duration.js